import styled from 'styled-components'
import vars from '../../variables'

const Background = styled.div`
  background-color: ${vars['color-silver']};
  min-height: 100vh;
`

export default Background



// WEBPACK FOOTER //
// ./src/components/MainBackground/index.js